<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
          <a class="navbar-brand" href="/" style=" -webkit-transition: all 5.5s ease;">
            <div class="logo-container brand">
              <img src="img/chad/chad-ashe-logo.png" alt="chad ashe logo">
            </div>
            Chad Ashe
          </a>
        </template>
        <template slot="navbar-menu">
          <router-link :to="{ path: `/about` }" class="nav-item nav-link company-navbar">
            {{ $t('about') }}
          </router-link>
          <a href="#photos" class="nav-item nav-link company-navbar">
            {{ $t('photos') }}
          </a>
          <a href="#news-article" class="nav-item nav-link company-navbar">
            {{ $t('newsArticles') }}
          </a>
          <a href="#snippet" class="nav-item nav-link company-navbar">
            {{ $t('snippet') }}
          </a>
          <a href="#latest-songs" class="nav-item nav-link company-navbar">
            {{ $t('music') }}
          </a>
          <a href="#download" class="nav-item nav-link company-navbar">
            {{ $t('download') }}
          </a>
          <a href="#mailing" class="nav-item nav-link company-navbar">
            {{ $t('subscribe') }}
          </a>
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    methods: {
      scrollMeTo(refName) {
        debugger
        var element = this.$refs[refName];
        debugger
        element.scrollIntoView();
      }
    }
  }
</script>

<style scoped>

</style>
